import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'semantic-ui-react'
import { ActionCable } from 'react-actioncable-provider';
import moment from 'moment';

import LibraryControlAction from '../../../actions/v2/library_control';
import { debounce, getText } from '../../../helpers';

function ControlLibraryTableMenu(props) {
  const [download_details, setDownloadDetails] = useState({});
  const [is_exporting, setIsExporting] = useState(false);
  const downloadRef = useRef(null);
  const { filters } = props.state;
  const controlsSearchTimer = useRef(null);

  const exportToExcel = () => {
    setIsExporting(true)

    filters.ignore_paging = true;
    filters.download_id = moment(new Date).format("YYYYMMDDHHmmss");
    filters.filename = constructFilename();
    props.exportControlsToExcel(filters);
  }

  const downloadExcel = () => {
    downloadRef.current.click();
    setIsExporting(false)
  }

  const constructFilename = () => {
    let filename = "library_controls";

    if (filters.search_term) {
      filename = `${filename}_(${filters.search_term.replace(' ','_')})`;
    }

    if (filters.include_archived) {
      filename = `${filename}_includes_archives`;
    }

    filename = `${filename}_${moment(new Date).format("MMM-DD-YYYY-HH-mm")}.xlsx`;
    return filename;
  }

  const handleExportChannelData = (data) => {
    if (filters.download_id !== data.download_id) return;

    setDownloadDetails({
      download_name: filters.filename,
      download_url: data.download_url
    })
  }
  
  const debouncedHandleSearchChange = (e) => {
    const value = e.target.value;
    controlsSearchTimer.current = debounce(
      () => props.handleSearchChange(null, { value }),
      1000,
      controlsSearchTimer.current
    )();
  };

  useEffect(()=>{
    if (download_details.download_name && download_details.download_url) downloadExcel();
  }, [download_details]);

  const { features } = props.instanceConfig
  const isEnabledTranslations = features && features.ai_translation

  return (
    <div className="control-lib-table-menu">
      <span>
        <Input className="search-library-control" icon='search' placeholder={`${getText("Search controls")}...`} onChange={debouncedHandleSearchChange}/>
        {
          props.state.filters.include_archived ?
          <span className='link text-light-blue hide-archived' onClick={() => props.hideArchivedLibraryControls()}>{getText("Hide Archived")}</span>
          :
          <span className='link text-light-blue show-archived' onClick={() => props.showArchivedLibraryControls()}>{getText("Show Archived")}</span>
        }
        {
          is_exporting
          ? <span className='export-to-excel italic'>Exporting <div className="ui active inline loader"></div></span>
          : <span className='link text-light-blue export-to-excel' onClick={() => exportToExcel()}>{getText("Export to Excel")}</span>
        }
        {
          download_details.download_name && download_details.download_url &&
          <a ref={downloadRef} href={download_details.download_url} download={download_details.download_name}></a>
        }
        <ActionCable channel={{channel: 'ExportChannel'}} onReceived={handleExportChannelData} />
      </span>
      <span className='action-buttons'>
        {isEnabledTranslations && <span><Button size='medium' onClick={props.showTranslationsModal}>{getText("Translations")}</Button></span>}
        <span><Button positive size='medium' className="create-control-button" onClick={props.showCreateControl}>{getText("Add Control")}</Button></span>
      </span>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    library_control: state.library_control,
    instanceConfig: state.instance.instanceConfig,
  }
}

const mapDispatchToProps = (dispatch) => {
  const libraryControlActions = new LibraryControlAction();

  return {
    exportControlsToExcel: (options) => {
      dispatch(libraryControlActions.exportControlsToExcel(options))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlLibraryTableMenu);


// WEBPACK FOOTER //
// ./src/views/control_library/table/control_library_table_menu.js